import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AccountScreen from './screens/AccountScreen';
import DeadlineScreen from './screens/DeadlineScreen';
import FinInfoScreen from './screens/FinInfoScreen';
import InfoScreen from './screens/InfoScreen';
import JidelnicekStaticScreen from './screens/JidelnicekStaticScreen';
import JidelnicekTextScreen from './screens/JidelnicekTextScreen';
import JidlaScreen from './screens/JidlaScreen';
import LoginByCardScreen from './screens/LoginByCardScreen';
import LoginScreen from './screens/LoginScreen';
import PasswordRecoveryScreen from './screens/PasswordRecoveryScreen';
import ProfileScreen from './screens/ProfileScreen';
import SettingsScreen from './screens/SettingsScreen';
import WelcomeScreen from './screens/WelcomeScreen';
import ZarizeniSelectionScreen from './screens/ZarizeniSelectionScreen';

function App() {
  return (
    <BrowserRouter basename="/estrava">
      <Routes>
        <Route path="/" element={<WelcomeScreen />} />
        <Route path="/vyber-jidelny" element={<ZarizeniSelectionScreen />} />
        <Route path="/prihlaseni/:selzar" element={<LoginScreen />} />
        <Route path="/prihlaseni" element={<LoginScreen />} />
        <Route path="/prihlaseni-karta/:selzar/:hashcheck" element={<LoginByCardScreen />} />
        <Route path="/zapomenute-heslo" element={<PasswordRecoveryScreen />} />
        <Route path="/jidelnicek" element={<JidlaScreen />} />
        <Route path="/jidelnicek-karta" element={<JidlaScreen />} />
        <Route path="/jidelnicek-vypis" element={<JidelnicekStaticScreen />} />
        <Route path="/jidelnicek-text" element={<JidelnicekTextScreen />} />
        <Route path="/casove-omezeni" element={<DeadlineScreen />} />
        <Route path="/sprava-uctu" element={<AccountScreen />} />
        <Route path="/informace" element={<InfoScreen />} />
        <Route path="/finance" element={<FinInfoScreen />} />
        <Route path="/nastaveni" element={<SettingsScreen />} />
        <Route path="/profily" element={<ProfileScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
